module.exports = __webpack_public_path__ + "img/ruiyan_02.a4fcbb9e.jpg";